export default __webpack_public_path__ + "static/media/img8.b05c04f6.png";